import React from 'react';

export const Logo: React.FC = () => {
  return (
    <div className="flex items-center gap-2">
      <span className="font-logo font-bold text-coral text-2xl">Ondako</span>
    </div>
  );
};
